import { useStaticQuery, graphql } from "gatsby";

export default filename => {
  if (!filename) return null;

  const data = useStaticQuery(graphql`
    {
      allImageSharp {
        edges {
          node {
            fluid(maxWidth: 3840, quality: 100) {
              originalName
              ...GatsbyImageSharpFluid_withWebp_tracedSVG
            }
          }
        }
      }
    }
  `);

  const image = data.allImageSharp.edges.find(i => i.node.fluid.originalName === filename);
  if (image) return image.node.fluid;
  return null;
};
